export default __webpack_public_path__ + "static/media/blue.6870bb99.webp";